export function getCurrentAccount() {
  return localStorage.getItem('current_account');
}

export function setCurrentAccount(accountID: string) {
  localStorage.setItem('current_account', accountID);
}
